import { render, staticRenderFns } from "./store-panel.vue?vue&type=template&id=28d8767e&scoped=true"
import script from "./store-panel.vue?vue&type=script&lang=ts&setup=true"
export * from "./store-panel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./store-panel.scss?vue&type=style&index=0&id=28d8767e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_css-loader@4.3.0_webpack@4.46.0__ejs@3.1.10_0212d38a6ce0de8ef75b0a1c6dc51def/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d8767e",
  null
  
)

export default component.exports